import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EstimateRowModel } from '@models/EstimateRow';
import { NGXLogger } from 'ngx-logger';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ExcelService extends BaseService {
  public constructor(private logger: NGXLogger, private http: HttpClient) {
    super();
  }

  /**
   *
   * @param data = EstimateRow[]
   */
  public generateExcel(data: EstimateRowModel[]) {
    const options = {
      responseType: 'blob' as 'json',
      observe: 'response' as 'body'
    };

    return this.http.post(this.baseUrl + '/web/Excel/', data, options).pipe(
      catchError((error, caught) => {
        this.logger.error('ExcelService.export() : ' + error);
        this.logger.error('ExcelService.export() : ' + caught);
        return EMPTY;
      })
    );
  }

  downloadFile(response, fileName) {
    const blob = new Blob([response.body], { type: response.type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a') as any;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = url;
    a.download = fileName + '.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
